const sendTokenCode = ({msisdn, tokenRecaptcha, isDev}) =>{
    const body = isDev ? {
        msisdn: msisdn.replace(/[^0-9]/g,'')
      } : {
        deliveryType: "SMS",
        telephoneNumber: msisdn.replace(/[^0-9]/g,'')
    }
    const path_url = `${isDev ? process.env.REACT_APP_OTP_TOKENS_URL_QA : process.env.REACT_APP_OTP_TOKENS_URL}`
    const payload_body = JSON.stringify(body)
    const request_method = 'POST'
    const payload_headers = {}
    payload_headers['Accept'] = 'application/json'
    payload_headers['Content-Type'] = 'application/json'
    if(isDev){
      payload_headers['client-id'] = 'MCLA'
      payload_headers['client-key'] = process.env.REACT_APP_CLIENT_KEY
      payload_headers['X-Client-Key'] = process.env.REACT_APP_X_CLIENT_KEY
      payload_headers['x-target'] = process.env.REACT_APP_TARGET_KEY
    }
    else{
      payload_headers['X-Captcha-Token'] = tokenRecaptcha
      payload_headers['X-Client-Key'] = process.env.REACT_APP_INVOICES_KEY

    }
    return fetch(path_url, {'body': payload_body, 'crossDomain': true, 'headers': payload_headers, 'method': request_method})
}
  
export {sendTokenCode}

